import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CustomMessageService, OriginMessageError } from 'library';

export const redirectTo404Guard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const customMessageService = inject(CustomMessageService);
  customMessageService.logErrorOnly({ route, state }, OriginMessageError.FRONTEND)
  router.navigate(['/pagina-no-encontrada'], { state: { attemptedUrl: state.url } });

  return false;
};
